module.exports = __webpack_public_path__ + "img/icon_package6.895c4920.png";